/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .theme-editor {
  }
`;
